// libraries
import React, { useState } from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import Balloon from '/react4xp/components/Balloon'
import Link from '/react4xp/components/Link'
import Mask from '/react4xp/components/Mask'
import Video from '/react4xp/components/Video'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// svg
import { UxArrowDown, UxArrowRight } from '/react4xp/components/Svg/Ux/Arrow'

// prop types
interface ListVideosProps {
    section: {
        bgColor: 'blue' | 'yoghurt' | string
        noSeparator?: boolean
        paddingTop?: 'small' | 'medium' | 'big' | 'none'
        paddingBottom?: 'small' | 'medium' | 'big' | 'none'
    }
    title?: string
    videos?: Array<{
        playText: string
        videoType: 'youtube' | 'vimeo' | 'default'
        poster: string
        url: string
        title?: string
    }>
    bottomLink?: {
        hasPagination: boolean 
        text: string
        href?: string
        external?: boolean
        isWhite?: boolean
    }
    howManyItems: number
}

export default function ListVideos({
    section,
    title,
    videos = [],
    bottomLink,
    howManyItems
}: ListVideosProps) {

    const [visibleVideos, setVisibleVideos] = useState(howManyItems)

    const loadMoreVideos = () => {
        setVisibleVideos(prevVisibleVideos => prevVisibleVideos + howManyItems)
    }

    return (
        <Section
            bgColor={section.bgColor}
            paddingTop={section.paddingTop}
            paddingBottom={section.paddingBottom}
            className='list-videos'
        >
            <div className='container'>

                {isNonWhitespaceString(title) && (
                    section?.bgColor !== 'yoghurt' ? (
                        <Balloon
                            balloonColor='white'
                            arrow='bottom-left'
                            arrowSide='right'
                            arrowSize='medium'
                            balloonSide='left'
                            spacing='small'
                            className='list-videos__title'
                        >
                            <h2 className='h1-hero-small'>
                                {title}
                            </h2>
                        </Balloon>
                    ) : (
                        <h2 className='h2 list-videos__title-center'>
                            {title}
                        </h2>
                    )
                )}

                <div className='list-videos__grid'>
                    {videos.slice(0, visibleVideos).map((item, i) => (
                        <Mask bgColor='white' key={i}>
                            
                            <Mask>
                                <Video
                                    video={{
                                        playButtonColor: 'blue',
                                        playText: item.playText,
                                        playTextColor: 'white',
                                        videoType: item.videoType,
                                        poster: item.poster, // 600x400
                                        posterMedium: item.poster, // 600x400
                                        url: item.url
                                    }}
                                />
                            </Mask>

                            {item.title && (
                                <h3 className='h4'>
                                    {item.title}
                                </h3>
                            )}

                        </Mask>
                    ))}
                </div>

                {bottomLink && bottomLink.hasPagination && visibleVideos < videos.length && (
                    <div className='list-videos__bottom-link'>
                        <button
                            onClick={loadMoreVideos}
                            className={clsx(
                                'link-w-icon',
                                'link-w-icon--icon-right',
                                'link-w-icon--no-motion-mobile'
                            )}
                        >
                            <span>{bottomLink.text}</span>
                            <UxArrowDown />
                        </button>
                    </div>
                )}

                {bottomLink && !bottomLink.hasPagination && bottomLink.text && (
                    <div className='list-videos__bottom-link'>
                        <Link
                            isWhite={bottomLink.isWhite}
                            noUnderline
                            text={bottomLink.text}
                            href={bottomLink.href}
                            target={!!bottomLink.external}
                            iconPosition='right'
                            icon={<UxArrowRight />}
                            noMotionMobile
                        />
                    </div>
                )}

            </div>
        </Section>
        
    )
}